import React from "react";
import ConfigurationGrid from "../../common/ConfigurationGrid";
import { hcmConfigSetupSections } from "../../../constants";

const HcmConfigurationSetup = ({ questionnaireData, setQuestionnaireData }) => {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-medium text-gray-900">
        HCM Configuration Setup
      </h3>
      <p className="text-gray-600">
        Define how your current HCM configurations will map to Workday HCM.
      </p>

      <div className="bg-yellow-50 p-4 rounded-lg mb-6">
        <p className="text-sm text-yellow-800">
          <strong>Tip:</strong> Use "Populate Examples" to quickly add sample
          data for demonstration purposes.
        </p>
        <p className="text-sm text-yellow-800 mt-2">
          <strong>Note:</strong> All configuration items include Legacy Name,
          Legacy Code, Description, New Name, New Description, and Comments. You
          can mark each record as "Not Required", "Merged", or "Keep". If
          "Merged" is selected, you'll need to map to another code. If "Keep" is
          selected, you'll need to provide the new code.
        </p>
      </div>

      {/* Render each HCM configuration section */}
      {hcmConfigSetupSections.map((section) => (
        <div
          key={section.id}
          className="border border-gray-200 rounded-lg p-4 mb-4"
        >
          <ConfigurationGrid
            category="configSetup"
            subcategory={section.id}
            title={section.title}
            examples={section.examples}
            questionnaireData={questionnaireData}
            setQuestionnaireData={setQuestionnaireData}
          />
        </div>
      ))}
    </div>
  );
};

export default HcmConfigurationSetup;
